import { CARD_CHECKOUT_CARD_EXPIRY, CARD_CHECKOUT_ONCE } from "src/components/constant/constant";

// Matches mobile resolveCardCheckoutDuration. allowed is null when the role is unrestricted or prefs haven't loaded,
// so the default is used as is. Otherwise: the longest allowed hours within the default, then ONCE, then the
// shortest allowed hours, else the default. CARD_EXPIRY isn't a number of hours, so the finite filter drops it.
export const pickCheckoutDuration = (allowed: string[] | null, defaultHours: number): string => {
  if (!allowed?.length) return String(defaultHours);

  const hours = allowed
    .filter((value) => value !== CARD_CHECKOUT_ONCE)
    .map(Number)
    .filter((value) => Number.isFinite(value) && value > 0)
    .sort((a, b) => a - b);
  const withinDefault = hours.filter((value) => value <= defaultHours);

  if (withinDefault.length) return String(withinDefault[withinDefault.length - 1]);
  if (allowed.includes(CARD_CHECKOUT_ONCE)) return CARD_CHECKOUT_ONCE;
  return hours.length ? String(hours[0]) : String(defaultHours);
};

// The create_card_setting link for a chosen duration: ONCE and CARD_EXPIRY go as link_type (the backend sets the
// end), hour values as an expiry. null for anything else, so a bad value can't fall back to a default length.
export const getCheckoutLink = (duration: string): { linkType: string } | { expireAt: string } | null => {
  if (duration === CARD_CHECKOUT_ONCE || duration === CARD_CHECKOUT_CARD_EXPIRY) return { linkType: duration };

  const hours = Number(duration);

  if (!Number.isFinite(hours) || hours <= 0) return null;
  return { expireAt: new Date(Date.now() + hours * 60 * 60 * 1000).toISOString() };
};
